var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-view"},[(!_vm.id)?_c('partner-list',{attrs:{"schemaId":_vm.schemaId}}):_c('partner',{attrs:{"schemaId":_vm.schemaId,"itemId":_vm.id},on:{"setPageTitle":_vm.setPageTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }